import { ReactComponent as ActiveSVG } from "../../../images/statuses/active.svg";
import { ReactComponent as DisabledSVG } from "../../../images/statuses/disabled.svg";
import { ReactComponent as DismissedSVG } from "../../../images/statuses/dismissed.svg";
import { ReactComponent as InformationSVG } from "../../../images/statuses/information.svg";
import { ReactComponent as InactiveSVG } from "../../../images/statuses/warning.svg";

interface Props {
	status?: string;
}

const EntityStatus = ({ status }: Props): JSX.Element => {
	switch (status) {
		case "ACTIVE":
		case "ENABLED":
		case "DEFAULT":
		case "OPEN":
			return <ActiveSVG className="entity-status" />;
		case "DISABLED":
			return <DisabledSVG className="entity-status" />;
		case "WARNING":
			return <InactiveSVG className="entity-status" />;
		case "INFORMATION":
		case "OPEN_BLUE":
			return <InformationSVG className="entity-status" />;
		case "DISMISSED":
			return <DismissedSVG className="entity-status" />;
		default:
			return <></>;
	}
};

export default EntityStatus;
